class ApiAuthentication {
    constructor(Restangular, ApiBaseResponseService) {
        return {

            validatePasswordToken(token) {
                return Restangular.all('authentication/password/reset')
                                  .get('validateToken', {'token': token })
                                  .then(ApiBaseResponseService.onSuccess, ApiBaseResponseService.onError);
            },

            resetPassword(password, token) {
                return Restangular.all('authentication/password/reset')
                                  .post({'token': token, 'password': password })
                                  .then(ApiBaseResponseService.onSuccess, ApiBaseResponseService.onError);
            },

            activateUser(token) {
                return Restangular.all('authentication/activate')
                                  .post(null, {'token': token})
                                  .then(ApiBaseResponseService.onSuccess, ApiBaseResponseService.onError);
            },

            loginUser(username, password) {
                return Restangular.all('authentication/login')
                                  .post({'username': username,'password': password})
                                  .then(ApiBaseResponseService.onSuccess, ApiBaseResponseService.onLoginError);
            },

            initiatePasswordReset(email){
                return Restangular.all('/authentication/password/reset/init')
                                  .post(null, {'email': email})
                                  .then(ApiBaseResponseService.onSuccess, ApiBaseResponseService.onError);
            }
        };
    }
}

ApiAuthentication.inject = ['Restangular', 'ApiBaseResponseService'];

export default ApiAuthentication;



/** WEBPACK FOOTER **
 ** ./src/app/services/apiAuthentication.js
 **/